import classNames from 'classnames'
import React, { useRef, forwardRef, useImperativeHandle, useState, CSSProperties, useEffect } from 'react'
import './index.less'

export interface TextareaProps {
  value?:string,
  wrapClassName?:string,
  wrapStyle?:CSSProperties,
  withBorder?:boolean,
  disabled?:boolean,
  onChange?: React.MouseEventHandler,
  onInput?: React.MouseEventHandler,
  onFocus?:React.MouseEventHandler,
  onBlur?:React.MouseEventHandler,
  maxLength?:number,
  prefix?:any,
  suffix?:any,
  maxHeight?:number,
  minHeight?:number,
}

export default forwardRef(({
  value = '',
  wrapClassName,
  wrapStyle,
  onChange,
  onInput,
  disabled,
  maxLength,
  onFocus,
  onBlur,
  prefix,
  suffix,
  maxHeight,
  minHeight = 24,
  ...otherProps
}:TextareaProps, ref) => {
  const [isFocus, setIsFocus] = useState(false)
  const $textarea = useRef<any>()

  useImperativeHandle(ref, () => ({
    $textarea: $textarea.current,
  }))

  const input = (e) => {
    onChange && onChange(e)
    onInput && onInput(e)
    if (maxHeight) {
      $textarea.current.style.height = 'inherit'
      $textarea.current.style.height = `${e.target.scrollHeight}px`
    }
  }
  const focus = (e) => {
    setIsFocus(true)
    onFocus?.(e)
  }
  const blur = (e) => {
    setIsFocus(false)
    onBlur?.(e)
  }

  useEffect(() => {
    if (!value) {
      $textarea.current.style.height = `${minHeight}px` || 'inherit'
    }
  }, [value, $textarea.current])

  return <div className={classNames('mn-textarea', wrapClassName, { focus: isFocus, disabled })} style={wrapStyle}>
    {prefix}
    <textarea
      ref={$textarea}
      value={value}
      onInput={input}
      onFocus={focus}
      onBlur={blur}
      disabled={disabled}
      maxLength={maxLength}
      {...otherProps}
    />
    {suffix}
  </div>
})
